import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConstants } from 'app/app.constants';
import {
  INTERCEPTConflict,
  INTERCEPTForbidden,
  INTERCEPTInternalServerError,
  INTERCEPTNotFound,
  INTERCEPTNotModified,
  INTERCEPTRequestTimeout,
  INTERCEPTServiceUnavailable,
  INTERCEPTUnauthorized,
} from './contexts';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(
    public router: Router,
    public toastr: ToastrService,
    public translate: TranslateService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let shouldIntercept = true;
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        let i18nKey = '';
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case HttpStatusCode.InternalServerError:
              shouldIntercept = request.context.get(INTERCEPTInternalServerError);
              if (shouldIntercept) this.router.navigate(['/manutencao']);
              break;

            case HttpStatusCode.Forbidden:
              shouldIntercept = request.context.get(INTERCEPTForbidden);
              if (shouldIntercept) i18nKey = 'errors.http.forbidden';
              break;

            case HttpStatusCode.NotFound:
              shouldIntercept = request.context.get(INTERCEPTNotFound);
              if (shouldIntercept) i18nKey = 'errors.http.not-found';
              break;

            case HttpStatusCode.Unauthorized:
              shouldIntercept = request.context.get(INTERCEPTUnauthorized);
              if (shouldIntercept) {
                localStorage.removeItem(
                  AppConstants.KEYS_LOCAL_STORAGE.ISO_ACCESS_TOKEN,
                );
                localStorage.removeItem(
                  AppConstants.KEYS_LOCAL_STORAGE.ISO_USUARIO,
                );
                this.router.navigate(['/login']);
              }
              break;

            case HttpStatusCode.RequestTimeout:
              shouldIntercept = request.context.get(INTERCEPTRequestTimeout);
              if (shouldIntercept) i18nKey = 'errors.http.timeout';
              break;

            case HttpStatusCode.Conflict:
              shouldIntercept = request.context.get(INTERCEPTConflict);
              if (shouldIntercept) i18nKey = 'errors.http.conflict';
              break;

            case HttpStatusCode.ServiceUnavailable:
              shouldIntercept = request.context.get(INTERCEPTServiceUnavailable);
              if (shouldIntercept) this.router.navigate(['/manutencao']);
              break;

            case HttpStatusCode.NotModified:
              shouldIntercept = request.context.get(INTERCEPTNotModified);
              if (shouldIntercept) i18nKey = 'errors.http.not-modified';
              break;

            default:
              break;
          }
          if (i18nKey) {
            this.translate
              .get(i18nKey)
              .subscribe((msg) => this.toastr.error(msg));
          }
        }
        return observableThrowError(err);
      }),
    );
  }
}
